import React, { useEffect } from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import { getUrlParam } from "../../../utils/urlParams";
import ProductList from "./components/ProductList";
import SideNavigation from "./components/SideNavigation";
import useStore from "./store";

const Container = styled.div`
    position: relative;
    display: grid;
    gap: 50px;
    grid-template-columns: 1fr;

    ${({ theme }) => theme.breakpoints.from.medium.css`
        grid-template-columns: 1fr 3fr;
  `}
`;

const OilFinder = () => {
    const [
        category,
        setCategory,
        categories,
        getData,
        needsReload,
        setNeedsReload,
    ] = useStore(
        (state) => [
            state.category,
            state.setCategory,
            state.categories,
            state.getData,
            state.needsReload,
            state.setNeedsReload,
        ],
        shallow
    );

    const categoryParam = Number(getUrlParam("category"));
    useEffect(() => {
        if (categories && category?.id !== categoryParam) {
            const targetCategory = categories.find(
                (cat) => cat.id === categoryParam
            );
            if (targetCategory) {
                setCategory(targetCategory);
                setNeedsReload(true);
            }
        }
    }, [categories, categoryParam]);

    useEffect(() => {
        if (needsReload) {
            getData();
        }
    }, [needsReload]);

    return (
        <Container>
            <SideNavigation />
            <ProductList />
        </Container>
    );
};

export default OilFinder;
